module.exports = __webpack_public_path__ + "static/img/TM.eaa250b1.svg";